import { render, staticRenderFns } from "./infoList.vue?vue&type=template&id=29550d72&scoped=true&"
import script from "./infoList.vue?vue&type=script&lang=js&"
export * from "./infoList.vue?vue&type=script&lang=js&"
import style0 from "./infoList.vue?vue&type=style&index=0&id=29550d72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29550d72",
  null
  
)

export default component.exports